import { createContext } from 'react';
import { ParsedToken } from './AuthModel';

export interface AuthContextProps {
  token?: string;
  parsedToken?: ParsedToken;
  authenticated: boolean;
  /**
   * Ger ett access-token som är giltigt i minst 30 sekunder till, och förnyar
   * det först om det behövs. Används av allt som anropar API:et med Bearer.
   * Kastar när användaren inte är inloggad eller sessionen inte går att förnya.
   */
  getAccessToken: () => Promise<string>;
  signOut: () => void;
}

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);
